import styled from "@xstyled/styled-components"

const Container = styled.box`
  border-top: 1px solid;
  border-color: dark;
  margin-top: 10;
`

export default Container
